import { render } from "./MobilePurchaseCompleteNatalChart.vue?vue&type=template&id=3f927a21&scoped=true"
import script from "./MobilePurchaseCompleteNatalChart.vue?vue&type=script&lang=js"
export * from "./MobilePurchaseCompleteNatalChart.vue?vue&type=script&lang=js"

import "./MobilePurchaseCompleteNatalChart.vue?vue&type=style&index=0&id=3f927a21&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f927a21"]])

export default __exports__